export enum EventName {
  ManualLogout = 'manualLogout',
  InvestButtonClick = 'investButtonClick',
  AppStoreButtonClick = 'appStoreButtonClick',
  PlayMarketButtonClick = 'playMarketButtonClick',
  HiddenFactoidButtonClick = 'hiddenFactoidButtonClick'
}
